import { createFileRoute } from '@tanstack/react-router';
import RegisterPage from '../pages/RegisterPage';

// Standalone Harborlight register screen (ported from source). Rendered WITHOUT
// the app shell, exactly like the source's /register route.
export const Route = createFileRoute('/register')({
  component: RegisterPage
});
